import { Center, Loader } from '#core/components';

export const LoaderPage = () => {
  return (
    <Center h="50vh">
      <Loader size="lg" />
    </Center>
  );
};
